// extracted by mini-css-extract-plugin
export var statItem = "_ij-1";
export var statsRow = "_ij-0";